import getActionsByDocument from '../../../../components/logs/actions';

const DOCUMENT = 'AGENCY_LOGS_';

export default getActionsByDocument(DOCUMENT);
